import { render, staticRenderFns } from "./deletePropertyRightRegistration.vue?vue&type=template&id=4d3d10a8&scoped=true"
import script from "./deletePropertyRightRegistration.vue?vue&type=script&lang=js"
export * from "./deletePropertyRightRegistration.vue?vue&type=script&lang=js"
import style0 from "./deletePropertyRightRegistration.vue?vue&type=style&index=0&id=4d3d10a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3d10a8",
  null
  
)

export default component.exports